import type { Setter } from 'solid-js'

import { Button } from '@components'
import { useService } from 'solid-services'
import { RotateCcw, Sparkle } from 'lucide-solid'
import { Flex, Grid } from 'styled-system/jsx'
import { useFilters } from '../state/filter'
import { AssetType } from './AssetType'
import Duration from './Duration'
import { NewSort } from './NewSort'
import { PatternSpecification } from './PatternSpecification'
import { Position } from './Position'
import { Stage } from './Stage'
import SymbolSearch from './Symbol'

export default function (props: { setIsOpen: Setter<boolean> }) {
	const { resetFilters } = useService(useFilters)()

	return (
		<Flex
			h="100%"
			flexDirection="column"
			justifyContent="space-between"
		>
			<Grid gap={4}>
				<SymbolSearch />
				<AssetType />
				<Position />
				<Stage />
				<PatternSpecification />
				<Duration />
        <NewSort />
				{/* <Source />
				<Order /> */}
			</Grid>
			<Flex justifyContent="space-between">
				<Button
					onClick={resetFilters}
					variant="outline"
					colorPalette="tscGreen"
				>
					Reset Filters
					<RotateCcw />
				</Button>

				<Button
					onClick={() => props.setIsOpen(false)}
					variant="solid"
					colorPalette="tscGreen"
				>
					Confirm
					<Sparkle />
				</Button>
			</Flex>
		</Flex>
	)
}
